// extracted by mini-css-extract-plugin
export default {"toggler":"toggler_toggler__UGg5w","label":"toggler_label__ESo6Q"};